// extracted by mini-css-extract-plugin
export default {"root":"root---pCTUe","userInfoLink":"userInfoLink---a8pTM"};